export const reachGoalFunk = (goal: string, type?: string) => {
  if (window.ym) {
    window.ym(87515319, type || 'reachGoal', goal);
    window.dataLayer.push({ event: goal });
  }
};
